var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _g, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _g2, _path57, _path58, _path59, _path60, _path61, _g3, _path62, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSurveyIllustTop(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 199,
    height: 192,
    viewBox: "0 0 199 192",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 99,
    cy: 96,
    r: 96,
    fill: "url(#paint0_linear_785_474)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M130.908 126.203L75.3734 99.7309C71.7936 98.0352 70.2392 93.7018 71.982 90.1219L105.661 19.4676C107.356 15.8878 111.69 14.3334 115.27 16.0762L170.804 42.548C174.384 44.2438 175.938 48.5772 174.195 52.157L140.517 122.811C138.821 126.391 134.487 127.946 130.908 126.203Z",
    fill: "#4489CA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M130.908 126.203L75.3734 99.7309C71.7936 98.0352 70.2392 93.7018 71.982 90.1219L105.661 19.4676C107.356 15.8878 111.69 14.3334 115.27 16.0762L170.804 42.548C174.384 44.2438 175.938 48.5772 174.195 52.157L140.517 122.811C138.821 126.391 134.487 127.946 130.908 126.203Z",
    fill: "url(#paint1_linear_785_474)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M130.391 122.434L78.6245 97.7525C75.2802 96.151 73.8671 92.1472 75.4686 88.8029L106.839 23.0002C108.441 19.6559 112.444 18.2428 115.789 19.8443L167.508 44.5262C170.852 46.1277 172.265 50.1315 170.663 53.4758L139.293 119.278C137.739 122.623 133.735 124.036 130.391 122.434Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M115.929 50.9322L108.251 47.2582C106.932 46.6458 106.367 45.0443 106.979 43.7254L110.653 36.0477C111.266 34.7288 112.867 34.1636 114.186 34.7759L121.864 38.4499C123.183 39.0623 123.748 40.6638 123.136 41.9826L119.462 49.6604C118.802 50.9793 117.248 51.5445 115.929 50.9322Z",
    fill: "#4489CA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M106.556 70.574L98.878 66.9C97.5591 66.2877 96.9939 64.6862 97.6062 63.3673L101.28 55.6895C101.893 54.3706 103.494 53.8054 104.813 54.4177L112.491 58.0918C113.81 58.7041 114.375 60.3056 113.763 61.6245L110.088 69.3022C109.476 70.6211 107.875 71.1864 106.556 70.574Z",
    fill: "#4489CA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M115.929 50.9322L108.251 47.2582C106.932 46.6458 106.367 45.0443 106.979 43.7254L110.653 36.0477C111.266 34.7288 112.867 34.1636 114.186 34.7759L121.864 38.4499C123.183 39.0623 123.748 40.6638 123.136 41.9826L119.462 49.6604C118.802 50.9793 117.248 51.5445 115.929 50.9322Z",
    fill: "url(#paint2_linear_785_474)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M116.589 48.3887L113.339 40.5225C113.15 40.0044 113.386 39.4391 113.904 39.2036C114.422 39.0152 114.987 39.2507 115.223 39.7688L117.719 45.798L131.05 40.8993C131.568 40.7109 132.133 40.9935 132.321 41.5116C132.51 42.0298 132.227 42.595 131.709 42.7834L116.589 48.3887Z",
    fill: "url(#paint3_linear_785_474)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M97.8419 87.6724L94.5918 79.8062C94.4034 79.288 94.6389 78.7228 95.157 78.4873C95.6752 78.2989 96.2404 78.5344 96.4759 79.0525L98.9724 85.0817L112.302 80.183C112.821 79.9946 113.386 80.2772 113.574 80.7953C113.763 81.3135 113.48 81.8787 112.962 82.0671L97.8419 87.6724Z",
    fill: "url(#paint4_linear_785_474)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M106.556 70.574L98.878 66.9C97.5591 66.2877 96.9939 64.6862 97.6062 63.3673L101.28 55.6895C101.893 54.3706 103.494 53.8054 104.813 54.4177L112.491 58.0918C113.81 58.7041 114.375 60.3056 113.763 61.6245L110.088 69.3022C109.476 70.6211 107.875 71.1864 106.556 70.574Z",
    fill: "url(#paint5_linear_785_474)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M107.215 68.0305L103.965 60.1643C103.776 59.6462 104.012 59.081 104.53 58.8455C105.048 58.657 105.613 58.8926 105.849 59.4107L108.345 65.4399L121.676 60.5412C122.194 60.3527 122.759 60.6354 122.947 61.1535C123.136 61.6716 122.853 62.2369 122.335 62.4253L107.215 68.0305Z",
    fill: "url(#paint6_linear_785_474)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M97.1817 90.2161L89.504 86.5421C88.1851 85.9297 87.6199 84.3283 88.2322 83.0094L91.9062 75.3316C92.5185 74.0127 94.12 73.4475 95.4389 74.0598L103.117 77.7339C104.436 78.3462 105.001 79.9477 104.388 81.2666L100.714 88.9443C100.102 90.2632 98.5006 90.8284 97.1817 90.2161Z",
    fill: "#4489CA"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M157.287 65.4871L130.956 52.9106C130.155 52.5338 129.826 51.5918 130.202 50.791C130.579 49.9903 131.521 49.6605 132.322 50.0374L158.653 62.6138C159.453 62.9906 159.783 63.9327 159.406 64.7335C159.029 65.5342 158.087 65.911 157.287 65.4871Z",
    fill: "#CEE9F2"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M148.759 83.4803L122.382 70.9038C121.581 70.527 121.251 69.5849 121.628 68.7842C122.005 67.9834 122.947 67.6537 123.748 68.0305L150.078 80.607C150.879 80.9838 151.209 81.9259 150.832 82.7266C150.502 83.5274 149.56 83.8571 148.759 83.4803Z",
    fill: "#CEE9F2"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M139.716 102.416L113.386 89.8391C112.585 89.4623 112.255 88.5202 112.632 87.7195C113.009 86.9187 113.951 86.589 114.752 86.9658L141.082 99.5423C141.883 99.9191 142.213 100.861 141.836 101.662C141.459 102.416 140.517 102.792 139.716 102.416Z",
    fill: "#CEE9F2"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M150.315 25.7795L150.362 25.6853C151.54 23.1889 150.504 20.1743 148.007 18.9967C145.511 17.8192 142.496 18.8554 141.319 21.3519L141.272 21.399C139.953 20.928 138.493 21.4932 137.88 22.765L135.384 28.0405L148.808 34.4465L151.305 29.2181C151.87 27.9463 151.446 26.4861 150.315 25.7795ZM145.558 23.9896C144.569 23.5186 144.145 22.2939 144.616 21.3048C145.087 20.3156 146.312 19.8917 147.301 20.3627C148.29 20.8337 148.714 22.0584 148.243 23.0476C147.772 24.0367 146.547 24.4607 145.558 23.9896Z",
    fill: "url(#paint7_linear_785_474)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M158.039 41.182L124.36 25.1199C126.621 20.4097 130.955 21.1162 135.665 23.33L152.292 31.2904C157.003 33.5042 160.3 36.4717 158.039 41.182Z",
    fill: "url(#paint8_linear_785_474)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_785_474",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 124,
    y: 21,
    width: 35,
    height: 21
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M158.039 41.182L124.36 25.1199C126.621 20.4097 130.955 21.1162 135.665 23.33L152.292 31.2904C157.003 33.5042 160.3 36.4717 158.039 41.182Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_785_474)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M160.865 46.7403L120.451 27.4753L122.618 23.0005L162.985 42.2656L160.865 46.7403Z",
    fill: "url(#paint9_linear_785_474)"
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M107.827 159.599L55.4016 171.28C48.713 172.787 42.0715 168.548 40.5642 161.86L15.1286 47.588C13.6213 40.8994 17.8606 34.2579 24.5492 32.7506L76.9747 21.0691C83.6633 19.5618 90.3048 23.801 91.8121 30.4896L117.248 144.761C118.755 151.45 114.563 158.091 107.827 159.599Z",
    fill: "black"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M108.91 158.185L56.4846 169.867C49.796 171.374 43.1545 167.135 41.6472 160.446L16.2116 46.1749C14.7043 39.4863 18.9436 32.8448 25.6322 31.3375L78.0577 19.656C84.7463 18.1487 91.3878 22.3879 92.8951 29.0765L118.331 143.348C119.838 150.037 115.599 156.678 108.91 158.185Z",
    fill: "#113868"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.56,
    d: "M108.91 158.185L56.4846 169.867C49.796 171.374 43.1545 167.135 41.6472 160.446L16.2116 46.1749C14.7043 39.4863 18.9436 32.8448 25.6322 31.3375L78.0577 19.656C84.7463 18.1487 91.3878 22.3879 92.8951 29.0765L118.331 143.348C119.838 150.037 115.599 156.678 108.91 158.185Z",
    fill: "url(#paint10_linear_785_474)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M88.1239 35.0506L23.1123 49.5168L45.7632 151.31L110.775 136.844L88.1239 35.0506Z",
    fill: "#CEE9F2"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.56,
    d: "M110.746 136.801L45.7444 151.262L23.0879 49.5194L88.1369 35.0117L110.746 136.801Z",
    fill: "url(#paint11_linear_785_474)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.56,
    d: "M110.746 136.801L45.7444 151.262L23.0879 49.5194L88.1369 35.0117L110.746 136.801Z",
    fill: "url(#paint12_linear_785_474)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M83.8998 45.0439L31.1446 56.7725C30.0613 57.008 29.3547 58.0914 29.5903 59.1747L32.6048 72.6932C32.8403 73.7766 33.9237 74.4832 35.0071 74.2476L39.2463 73.3056L43.7211 78.2043L45.6994 71.8454L87.7152 62.4719C88.7985 62.2364 89.5051 61.153 89.2696 60.0697L86.3492 46.5983C86.1137 45.5149 85.0303 44.8084 83.8998 45.0439Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M45.6531 67.4469C47.5855 64.4836 46.7498 60.5148 43.7864 58.5823C40.823 56.6499 36.8542 57.4857 34.9218 60.449C32.9894 63.4124 33.8251 67.3812 36.7885 69.3136C39.7519 71.2461 43.7207 70.4103 45.6531 67.4469Z",
    fill: "#CEE9F2"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0829 63.4617C41.6953 62.9907 42.0721 62.1899 41.8837 61.3421C41.6482 60.2116 40.5177 59.505 39.3872 59.7877C38.2568 60.0232 37.5502 61.1536 37.8328 62.2841C38.0212 63.0849 38.6807 63.6972 39.4343 63.8856C38.5394 64.4508 38.0683 65.5342 38.3039 66.6176L38.6336 68.1249L43.6265 66.9944L43.2968 65.4871C43.0141 64.3566 42.1192 63.5559 41.0829 63.4617Z",
    fill: "#E60011"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M82.9801 58.245L51.21 65.3145L51.5169 66.6938L83.2871 59.6243L82.9801 58.245Z",
    fill: "#CEE9F2"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2753 56.9403L64.9004 53.4634L65.2073 54.8427L49.5822 58.3196L49.2753 56.9403Z",
    fill: "#CEE9F2"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3721 62.0415L82.167 54.9666L82.4739 56.3459L50.679 63.4208L50.3721 62.0415Z",
    fill: "#CEE9F2"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M91.435 78.864L38.6798 90.5926C37.5964 90.8281 36.8899 91.9115 37.1254 92.9948L40.14 106.513C40.3755 107.597 41.4589 108.303 42.5422 108.068L46.7815 107.126L51.2563 112.024L53.2346 105.666L95.2503 96.292C96.3337 96.0565 97.0403 94.9732 96.8047 93.8898L93.7901 80.3713C93.6017 79.2879 92.5184 78.5814 91.435 78.864Z",
    fill: "white"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M90.6589 92.2567L58.8887 99.3262L59.1956 100.705L90.9658 93.636L90.6589 92.2567Z",
    fill: "#CEE9F2"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M56.954 90.952L72.5791 87.4751L72.886 88.8544L57.2609 92.3313L56.954 90.952Z",
    fill: "#CEE9F2"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0508 96.0532L89.8457 88.9783L90.1526 90.3576L58.3577 97.4325L58.0508 96.0532Z",
    fill: "#CEE9F2"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M49.7316 103.811C53.1064 102.749 54.9819 99.1529 53.9205 95.7781C52.8591 92.4032 49.2628 90.5278 45.888 91.5892C42.5132 92.6506 40.6378 96.2468 41.6991 99.6217C42.7605 102.996 46.3568 104.872 49.7316 103.811Z",
    fill: "#CEE9F2"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5712 97.2339C49.1835 96.7629 49.5604 95.9621 49.372 95.1143C49.1364 93.9838 48.006 93.2773 46.8755 93.5599C45.745 93.8425 45.0385 94.9259 45.3211 96.0563C45.5095 96.8571 46.169 97.4694 46.9226 97.6578C46.0277 98.2231 45.5566 99.3064 45.7921 100.39L46.1219 101.897L51.1148 100.767L50.785 99.2593C50.5024 98.1289 49.6075 97.3752 48.5712 97.2339Z",
    fill: "#E60011"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M98.9721 112.637L46.2169 124.366C45.1335 124.601 44.427 125.684 44.6625 126.768L47.6771 140.286C47.9126 141.37 48.996 142.076 50.0793 141.841L54.3186 140.899L58.7934 145.797L60.7717 139.438L102.787 130.065C103.871 129.83 104.577 128.746 104.342 127.663L101.327 114.144C101.139 113.061 100.055 112.401 98.9721 112.637Z",
    fill: "white"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M98.3405 126.268L66.5703 133.338L66.8772 134.717L98.6474 127.648L98.3405 126.268Z",
    fill: "#CEE9F2"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M64.6356 124.964L80.2607 121.487L80.5677 122.866L64.9425 126.343L64.6356 124.964Z",
    fill: "#CEE9F2"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M65.7324 130.065L97.5273 122.99L97.8343 124.37L66.0393 131.444L65.7324 130.065Z",
    fill: "#CEE9F2"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M57.4623 137.562C60.8035 136.399 62.5694 132.748 61.4065 129.406C60.2435 126.065 56.5922 124.299 53.251 125.462C49.9098 126.625 48.1439 130.276 49.3068 133.618C50.4697 136.959 54.1211 138.725 57.4623 137.562Z",
    fill: "#CEE9F2"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1073 131.007C56.7197 130.536 57.0965 129.736 56.9081 128.888C56.6726 127.757 55.5421 127.051 54.4116 127.333C53.2812 127.569 52.5746 128.699 52.8572 129.83C53.0457 130.631 53.7051 131.243 54.4587 131.431C53.5638 131.997 53.0928 133.08 53.3283 134.163L53.658 135.671L58.6509 134.54L58.3212 133.033C58.0386 131.902 57.1436 131.149 56.1073 131.007Z",
    fill: "#E60011"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M92.1893 154.276L70.0039 159.222C68.4024 159.598 66.7538 158.562 66.4241 156.914C66.0472 155.312 67.0835 153.663 68.7321 153.334L90.9176 148.388C92.5191 148.011 94.1676 149.047 94.4974 150.696C94.8271 152.297 93.7908 153.899 92.1893 154.276Z",
    fill: "#4489CA"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M92.1893 155.312L70.0039 160.258C68.4024 160.635 66.7538 159.598 66.4241 157.95C66.0472 156.348 67.0835 154.7 68.7321 154.37L90.9176 149.424C92.5191 149.047 94.1676 150.083 94.4974 151.732C94.8271 153.334 93.7908 154.982 92.1893 155.312Z",
    fill: "black"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M57.4754 33.363L40.801 37.0841C40.1887 37.2254 39.5292 36.8486 39.3879 36.1891C39.2466 35.5768 39.6234 34.9174 40.2829 34.776L56.9573 31.0549C57.5696 30.9136 58.2291 31.2904 58.3704 31.9499C58.5117 32.6093 58.0878 33.2217 57.4754 33.363Z",
    fill: "#4489CA"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M67.0838 30.0186C67.2722 30.9607 66.7069 31.9027 65.7649 32.0911C64.8228 32.2795 63.8808 31.7143 63.6923 30.7722C63.5039 29.8302 64.0692 28.8881 65.0112 28.6997C65.9533 28.4642 66.8482 29.0765 67.0838 30.0186Z",
    fill: "#4489CA"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9911 34.2577L41.3166 37.9317C40.7043 38.0731 40.0449 37.6962 39.9036 37.0368C39.7622 36.4245 40.1391 35.765 40.7985 35.6237L57.4729 31.9026C58.0853 31.7613 58.7447 32.1381 58.886 32.7975C59.0273 33.457 58.6034 34.1164 57.9911 34.2577Z",
    fill: "#010C1C"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M67.6013 30.9134C67.7897 31.8554 67.2245 32.7975 66.2825 32.9859C65.3404 33.1743 64.3983 32.6091 64.2099 31.667C64.0215 30.725 64.5868 29.7829 65.5288 29.5945C66.4709 29.359 67.4129 29.9713 67.6013 30.9134Z",
    fill: "#010C1C"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M158.039 140.475C158.133 140.522 158.18 140.569 158.274 140.616C158.557 140.805 158.793 141.04 159.028 141.276C159.169 141.417 159.358 141.606 159.499 141.747L155.448 136.989C155.401 136.895 155.307 136.848 155.26 136.754C155.166 136.66 155.119 136.566 155.024 136.518C154.789 136.283 154.506 136.047 154.271 135.859C154.224 135.859 154.224 135.812 154.176 135.765C154.129 135.718 154.082 135.718 154.035 135.671C153.847 135.529 153.658 135.435 153.47 135.294C153.376 135.247 153.329 135.2 153.234 135.152C152.952 135.011 152.669 134.917 152.387 134.823C152.151 134.729 151.868 134.681 151.633 134.587C151.209 134.493 150.785 134.446 150.361 134.399C150.267 134.399 150.173 134.399 150.079 134.399C149.655 134.399 149.231 134.399 148.854 134.399H148.807C148.76 134.399 148.665 134.399 148.618 134.446C148.336 134.493 148.1 134.493 147.818 134.54C147.723 134.54 147.582 134.587 147.488 134.587C147.252 134.634 147.017 134.681 146.781 134.729C146.734 134.729 146.64 134.776 146.593 134.776C146.546 134.776 146.546 134.776 146.499 134.823C146.169 134.917 145.792 135.011 145.462 135.105C145.415 135.105 145.368 135.152 145.274 135.152C144.991 135.247 144.709 135.341 144.473 135.435C144.426 135.435 144.379 135.482 144.332 135.482C144.285 135.482 144.238 135.529 144.191 135.529C144.096 135.576 143.955 135.623 143.861 135.671C143.767 135.718 143.625 135.765 143.531 135.812C143.437 135.859 143.343 135.906 143.249 135.953C143.154 136 143.06 136.047 142.966 136.094C142.872 136.142 142.778 136.189 142.73 136.236C142.636 136.283 142.542 136.33 142.448 136.377C142.354 136.424 142.307 136.471 142.259 136.471C142.212 136.471 142.212 136.518 142.165 136.518C142.118 136.566 142.071 136.566 142.024 136.613C141.977 136.66 141.93 136.66 141.883 136.707C141.836 136.754 141.788 136.754 141.741 136.754L139.386 134.022C139.292 133.881 139.151 133.739 139.009 133.645C138.915 133.551 138.821 133.457 138.727 133.363C138.633 133.268 138.491 133.127 138.397 133.033C138.209 132.844 138.02 132.703 137.832 132.515C137.69 132.42 137.596 132.326 137.455 132.185C137.408 132.138 137.361 132.138 137.314 132.091C137.125 131.949 136.89 131.855 136.701 131.714C136.56 131.62 136.466 131.526 136.324 131.478C135.948 131.243 135.524 131.054 135.053 130.913C134.817 130.819 134.535 130.772 134.252 130.678C133.922 130.583 133.545 130.536 133.169 130.489C133.074 130.489 132.933 130.489 132.792 130.489C132.509 130.489 132.274 130.489 131.991 130.489C131.944 130.489 131.85 130.489 131.803 130.489C131.661 130.489 131.473 130.536 131.332 130.536C131.284 130.536 131.19 130.536 131.143 130.583C130.861 130.631 130.578 130.678 130.248 130.772C130.201 130.772 130.107 130.819 130.06 130.819C129.683 130.913 129.353 131.054 128.976 131.196C128.882 131.243 128.835 131.243 128.741 131.29C128.553 131.337 128.411 131.431 128.27 131.526C128.129 131.62 127.94 131.667 127.799 131.761C127.705 131.808 127.563 131.902 127.469 131.949C127.281 132.044 127.139 132.138 126.998 132.232C126.904 132.279 126.763 132.373 126.668 132.42C126.527 132.515 126.386 132.609 126.292 132.703C126.103 132.844 125.915 132.986 125.773 133.127C125.679 133.174 125.632 133.221 125.538 133.315C125.444 133.41 125.35 133.504 125.255 133.598C125.02 133.834 124.784 134.069 124.549 134.305C124.455 134.399 124.36 134.446 124.313 134.54C124.219 134.634 124.125 134.776 124.031 134.917C123.889 135.058 123.795 135.247 123.654 135.388C123.465 135.623 123.324 135.906 123.136 136.142C123.041 136.283 122.947 136.471 122.853 136.613C122.712 136.895 122.523 137.178 122.429 137.508C122.382 137.649 122.288 137.79 122.241 137.932C122.052 138.403 121.864 138.826 121.77 139.345C120.828 142.783 120.404 147.776 122.759 153.57C123.842 156.207 125.491 158.986 127.94 161.907L131.991 166.664C124.125 157.432 124.407 149.095 125.821 144.102C125.962 143.631 126.103 143.16 126.292 142.689C126.339 142.548 126.433 142.406 126.48 142.265C126.621 141.982 126.763 141.653 126.904 141.37C126.998 141.182 127.092 141.04 127.187 140.899C127.328 140.663 127.516 140.381 127.705 140.145C127.846 140.004 127.94 139.816 128.081 139.674C128.27 139.486 128.411 139.25 128.6 139.062C128.835 138.826 129.071 138.591 129.306 138.355C129.495 138.214 129.636 138.026 129.824 137.884C130.013 137.743 130.201 137.602 130.342 137.46C130.578 137.272 130.813 137.131 131.049 136.989C131.19 136.895 131.379 136.801 131.52 136.707C131.803 136.566 132.085 136.424 132.368 136.283C132.509 136.189 132.698 136.142 132.839 136.047C133.263 135.859 133.687 135.718 134.158 135.576C134.535 135.482 134.911 135.388 135.241 135.341C135.288 135.341 135.382 135.341 135.43 135.294C135.665 135.247 135.901 135.247 136.089 135.247C136.372 135.247 136.654 135.247 136.89 135.247C137.031 135.247 137.125 135.247 137.267 135.247C137.643 135.294 138.02 135.341 138.35 135.435C138.633 135.482 138.868 135.576 139.151 135.671C139.575 135.812 139.998 136 140.422 136.236C140.564 136.33 140.658 136.377 140.799 136.471C141.035 136.613 141.223 136.754 141.459 136.895H141.412C141.364 136.895 141.364 136.942 141.364 136.942L145.415 141.7C145.415 141.7 145.462 141.7 145.462 141.653H145.51C145.557 141.653 145.604 141.606 145.651 141.558C145.698 141.558 145.698 141.511 145.745 141.511C145.792 141.464 145.886 141.464 145.933 141.417C145.981 141.417 146.028 141.37 146.075 141.323C146.122 141.276 146.216 141.229 146.31 141.182C146.357 141.135 146.452 141.135 146.499 141.087C146.593 141.04 146.687 140.993 146.781 140.946C146.876 140.899 146.923 140.852 147.017 140.805C147.111 140.758 147.205 140.711 147.299 140.663C147.394 140.616 147.488 140.569 147.582 140.522C147.676 140.475 147.818 140.428 147.912 140.381C148.006 140.334 148.1 140.287 148.242 140.24C148.336 140.192 148.43 140.145 148.524 140.145C148.807 140.051 149.042 139.957 149.325 139.863C149.372 139.863 149.419 139.816 149.513 139.816C149.843 139.721 150.173 139.627 150.55 139.533C150.644 139.486 150.738 139.486 150.832 139.486C151.068 139.439 151.303 139.392 151.539 139.345C151.633 139.345 151.774 139.297 151.868 139.297C152.151 139.25 152.387 139.203 152.669 139.203C152.763 139.203 152.858 139.203 152.905 139.156C153.329 139.109 153.753 139.109 154.129 139.156C154.224 139.156 154.318 139.156 154.412 139.156C154.836 139.203 155.26 139.25 155.684 139.345C155.966 139.392 156.202 139.486 156.437 139.58C156.72 139.674 157.003 139.816 157.285 139.91C157.379 139.957 157.427 140.004 157.521 140.051C157.662 140.24 157.85 140.334 158.039 140.475Z",
    fill: "#AB000C"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M155.59 139.439C155.873 139.486 156.108 139.58 156.344 139.674C157.286 140.004 158.181 140.522 158.981 141.323C161.666 143.96 162.09 148.2 160.253 152.062C157.71 157.385 151.209 165.581 134.865 169.82H134.723L134.629 169.773C123.748 159.316 123.984 149.66 125.491 144.102C126.575 140.098 129.919 136.659 133.97 135.576C135.571 135.152 136.937 135.152 138.209 135.435C138.492 135.482 138.727 135.576 139.01 135.67C143.202 137.13 145.227 141.652 145.274 141.747C145.369 141.699 150.833 138.308 155.59 139.439Z",
    fill: "#E8365C"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M155.589 139.439C155.872 139.486 156.107 139.58 156.343 139.674C157.285 140.004 158.18 140.522 158.98 141.323C161.665 143.96 162.089 148.2 160.252 152.062C157.709 157.385 151.208 165.581 134.864 169.82H134.722L134.628 169.773C123.747 159.316 123.983 149.66 125.49 144.102C126.574 140.098 129.918 136.659 133.969 135.576C135.57 135.152 136.936 135.152 138.208 135.435C138.491 135.482 138.726 135.576 139.009 135.67C143.201 137.13 145.226 141.652 145.273 141.747C145.368 141.699 150.832 138.308 155.589 139.439Z",
    fill: "url(#paint13_linear_785_474)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M136.418 135.529C137.03 135.529 137.595 135.576 138.161 135.718C138.396 135.765 138.679 135.859 138.914 135.953C142.777 137.319 144.755 141.37 144.991 141.841L145.132 142.124L145.415 141.982C146.121 141.558 149.795 139.486 153.563 139.486C154.27 139.486 154.929 139.58 155.542 139.721C155.777 139.768 156.06 139.863 156.295 139.957C157.237 140.287 158.085 140.805 158.839 141.511C161.382 144.008 161.853 148.106 160.016 151.921C158.415 155.312 155.871 158.421 152.574 161.106C148.005 164.827 142.07 167.653 134.816 169.537C130.059 164.921 126.997 160.07 125.726 155.03C124.783 151.403 124.831 147.729 125.82 144.196C126.903 140.192 130.153 136.942 134.063 135.906C134.863 135.671 135.664 135.529 136.418 135.529ZM136.418 135.247C135.664 135.247 134.863 135.341 134.016 135.576C129.965 136.66 126.62 140.098 125.537 144.102C124.03 149.66 123.794 159.316 134.675 169.773L134.769 169.82H134.911C151.302 165.581 157.755 157.338 160.299 152.062C162.136 148.2 161.712 143.961 159.027 141.323C158.227 140.522 157.332 140.004 156.39 139.674C156.154 139.58 155.871 139.533 155.636 139.439C154.976 139.297 154.27 139.203 153.61 139.203C149.465 139.203 145.367 141.7 145.32 141.747C145.273 141.653 143.248 137.131 139.056 135.671C138.82 135.576 138.538 135.529 138.255 135.435C137.643 135.341 137.03 135.247 136.418 135.247Z",
    fill: "url(#paint14_linear_785_474)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M165.245 96.999C164.821 97.2345 164.397 97.423 164.021 97.6585",
    stroke: "#233972",
    strokeWidth: 0.429323,
    strokeMiterlimit: 10
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M161.618 99.1189C159.357 100.579 157.238 102.275 155.542 104.347C152.951 107.503 151.35 111.648 151.915 115.699C152.857 122.199 159.263 126.862 165.763 127.71C172.264 128.558 178.764 126.344 184.746 123.612C186.865 122.67 188.985 121.587 190.681 120.033C192.376 118.478 193.648 116.264 193.648 113.956C193.648 110.659 191.01 107.786 187.855 106.75C184.746 105.713 181.26 106.231 178.198 107.362C173.63 109.058 169.437 112.213 167.412 116.641C165.387 121.069 165.858 126.768 169.296 130.207C170.945 131.855 173.111 132.892 175.325 133.598C182.296 135.812 190.163 134.917 196.474 131.337C199.96 129.359 197.558 123.895 193.837 125.308C193.742 125.355 193.601 125.402 193.507 125.449C190.869 126.674 189.55 129.924 189.88 132.845C190.21 135.765 191.905 138.356 193.884 140.475",
    stroke: "#233972",
    strokeWidth: 0.429323,
    strokeMiterlimit: 10,
    strokeDasharray: "2.55 2.55"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M159.734 96.4807L165.198 100.202L154.176 101.898L148.665 98.1764L159.734 96.4807Z",
    fill: "url(#paint15_linear_785_474)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M175.466 75.3786L176.031 86.7304L170.52 83.0564L169.955 71.7046L175.466 75.3786Z",
    fill: "url(#paint16_linear_785_474)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M185.311 92.0532L174.995 97.0932L172.122 108.445L166.658 104.724L169.484 93.4191L179.8 88.332L185.311 92.0532Z",
    fill: "url(#paint17_linear_785_474)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M159.734 96.4807L165.198 100.202L154.176 101.898L148.665 98.1764L159.734 96.4807Z",
    fill: "url(#paint18_linear_785_474)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.466 75.3786L176.031 86.7304L170.52 83.0564L169.955 71.7046L175.466 75.3786Z",
    fill: "url(#paint19_linear_785_474)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.311 92.0532L174.995 97.0932L172.122 108.445L166.658 104.724L169.484 93.4191L179.8 88.332L185.311 92.0532Z",
    fill: "url(#paint20_linear_785_474)"
  }))), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M169.956 71.7046L161.43 79.7121L150.738 77.7809L154.741 88.0493L148.665 98.1764L159.734 96.4807L166.658 104.724L169.485 93.419L179.8 88.3319L170.521 83.0564L169.956 71.7046Z",
    fill: "url(#paint21_linear_785_474)",
    stroke: "url(#paint22_linear_785_474)",
    strokeWidth: 0.282967,
    strokeMiterlimit: 10
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1086 140.211C34.1056 151.808 20.6288 156.836 10.7572 151.265C8.63976 150.066 6.66544 148.266 6.23624 145.867C4.06163 133.327 32.4174 135.812 25.6647 147.781C20.9149 156.179 9.64123 160.92 1 163.891",
    stroke: "#233972",
    strokeWidth: 0.429323,
    strokeMiterlimit: 10,
    strokeDasharray: "2.58 2.58"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8812 142.634L41.3701 146.355L52.3922 148.051L57.9032 144.33L46.8812 142.634Z",
    fill: "url(#paint23_linear_785_474)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1021 121.532L30.584 132.884L36.0479 129.163L36.6132 117.811L31.1021 121.532Z",
    fill: "url(#paint24_linear_785_474)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3047 138.207L31.6202 143.247L34.4464 154.552L39.9574 150.831L37.1313 139.526L26.8157 134.486L21.3047 138.207Z",
    fill: "url(#paint25_linear_785_474)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.8812 142.634L41.3701 146.355L52.3922 148.051L57.9032 144.33L46.8812 142.634Z",
    fill: "url(#paint26_linear_785_474)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1021 121.532L30.584 132.884L36.0479 129.163L36.6132 117.811L31.1021 121.532Z",
    fill: "url(#paint27_linear_785_474)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3047 138.207L31.6202 143.247L34.4464 154.552L39.9574 150.831L37.1313 139.526L26.8157 134.486L21.3047 138.207Z",
    fill: "url(#paint28_linear_785_474)"
  }))), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6128 117.811L45.1855 125.866L55.8308 123.887L51.8742 134.156L57.9033 144.33L46.8812 142.634L39.9571 150.83L37.131 139.525L26.8154 134.485L36.0476 129.163L36.6128 117.811Z",
    fill: "url(#paint29_linear_785_474)",
    stroke: "url(#paint30_linear_785_474)",
    strokeWidth: 0.282967,
    strokeMiterlimit: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_785_474",
    x1: 3,
    y1: -18.6667,
    x2: 145.4,
    y2: 174.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD452"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.749499,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_785_474",
    x1: 76.617,
    y1: 18.755,
    x2: 154.36,
    y2: 134.836,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E90111"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.976066,
    stopColor: "#A8010D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_785_474",
    x1: 107.592,
    y1: 35.0358,
    x2: 118.849,
    y2: 53.1271,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E90111"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.976066,
    stopColor: "#A8010D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_785_474",
    x1: 113.277,
    y1: 43.7628,
    x2: 132.411,
    y2: 43.7628,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0698322,
    stopColor: "#FFA30D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFF0D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_785_474",
    x1: 94.5538,
    y1: 83.0426,
    x2: 113.688,
    y2: 83.0426,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0698322,
    stopColor: "#FFA30D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFF0D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_785_474",
    x1: 98.219,
    y1: 54.6776,
    x2: 109.476,
    y2: 72.769,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E90111"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.976066,
    stopColor: "#A8010D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_785_474",
    x1: 103.915,
    y1: 63.4027,
    x2: 123.049,
    y2: 63.4027,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0698322,
    stopColor: "#FFA30D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFF0D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_785_474",
    x1: 138.315,
    y1: 21.9041,
    x2: 151.728,
    y2: 28.2977,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#706D6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0632427,
    stopColor: "#6D6B6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2527,
    stopColor: "#68696B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3313,
    stopColor: "#797A7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4863,
    stopColor: "#A4A7A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6061,
    stopColor: "#C9CDCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8655,
    stopColor: "#888784"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A6763"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_785_474",
    x1: 125.733,
    y1: 22.1926,
    x2: 159.424,
    y2: 38.2524,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#706D6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0632427,
    stopColor: "#6D6B6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2527,
    stopColor: "#68696B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3313,
    stopColor: "#797A7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4863,
    stopColor: "#A4A7A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6061,
    stopColor: "#C9CDCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8655,
    stopColor: "#888784"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A6763"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_785_474",
    x1: 121.538,
    y1: 25.2398,
    x2: 161.935,
    y2: 44.4964,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6763"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1345,
    stopColor: "#888784"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3939,
    stopColor: "#C9CDCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5137,
    stopColor: "#A4A7A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6687,
    stopColor: "#797A7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7473,
    stopColor: "#68696B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9368,
    stopColor: "#6D6B6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#706D6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_785_474",
    x1: 97.6402,
    y1: 20.3097,
    x2: 67.2232,
    y2: 94.8975,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 2.6e-7,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4795,
    stopColor: "white",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.743,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_785_474",
    x1: 101.169,
    y1: 38.1268,
    x2: 64.1394,
    y2: 97.6383,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 2.6e-7,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4795,
    stopColor: "white",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.743,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_785_474",
    x1: 101.169,
    y1: 38.1268,
    x2: 64.1394,
    y2: 97.6383,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 2.6e-7,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4795,
    stopColor: "white",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.743,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_785_474",
    x1: 126.631,
    y1: 136.29,
    x2: 149.394,
    y2: 175.043,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E90111"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.976066,
    stopColor: "#A8010D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_785_474",
    x1: 124.481,
    y1: 146.635,
    x2: 157.536,
    y2: 159.321,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0661082,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B556B5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_785_474",
    x1: 164.946,
    y1: 101.246,
    x2: 148.953,
    y2: 97.1363,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDD0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB10D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_785_474",
    x1: 177.658,
    y1: 80.4116,
    x2: 168.35,
    y2: 78.0194,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDD0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB10D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_785_474",
    x1: 183.199,
    y1: 100.238,
    x2: 168.688,
    y2: 96.5082,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDD0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB10D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_785_474",
    x1: 164.946,
    y1: 101.246,
    x2: 148.953,
    y2: 97.1363,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDD0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB10D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_785_474",
    x1: 177.658,
    y1: 80.4116,
    x2: 168.35,
    y2: 78.0194,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDD0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB10D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_785_474",
    x1: 183.199,
    y1: 100.238,
    x2: 168.688,
    y2: 96.5082,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDD0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB10D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_785_474",
    x1: 179.126,
    y1: 90.9782,
    x2: 149.32,
    y2: 83.3182,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0698322,
    stopColor: "#FFA30D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFF0D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_785_474",
    x1: 179.447,
    y1: 91.0275,
    x2: 149.049,
    y2: 83.2155,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 2.6e-7,
    stopColor: "#FFFF0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9302,
    stopColor: "#FFA30D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_785_474",
    x1: 41.6527,
    y1: 147.388,
    x2: 57.6451,
    y2: 143.278,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDD0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB10D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_785_474",
    x1: 28.9403,
    y1: 126.553,
    x2: 38.2487,
    y2: 124.161,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDD0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB10D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_785_474",
    x1: 23.3993,
    y1: 146.38,
    x2: 37.9107,
    y2: 142.65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDD0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB10D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_785_474",
    x1: 41.6527,
    y1: 147.388,
    x2: 57.6451,
    y2: 143.278,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDD0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB10D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_785_474",
    x1: 28.9403,
    y1: 126.553,
    x2: 38.2487,
    y2: 124.161,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDD0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB10D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_785_474",
    x1: 23.3993,
    y1: 146.38,
    x2: 37.9107,
    y2: 142.65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDD0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB10D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_785_474",
    x1: 27.4725,
    y1: 137.12,
    x2: 57.2784,
    y2: 129.46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0698322,
    stopColor: "#FFA30D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFF0D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_785_474",
    x1: 27.1515,
    y1: 137.169,
    x2: 57.549,
    y2: 129.357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 2.6e-7,
    stopColor: "#FFFF0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9302,
    stopColor: "#FFA30D"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurveyIllustTop);
export default __webpack_public_path__ + "static/media/survey-illust-top.80fc68d2e4dcd75215491318e5ff25ca.svg";
export { ForwardRef as ReactComponent };